import React, { useState, useEffect } from 'react'
import { BackTop } from 'antd'
import { IconSvg } from '@/components'
import styles from './index.module.less'

const MyBackTop = React.memo(({ scrollContainer = 'inspiration-layout-container' }: any) => {
  const [target, setTarget] = useState<any>(null)

  useEffect(() => {
    if (scrollContainer && document && document.querySelector) {
      const t = document.querySelector(`#${scrollContainer}`)
      if (t) {
        setTarget(t)
      }
    }
  }, [])

  return (
    <BackTop
      target={() => target || <div />}
      visibilityHeight={300}
      style={{ right: 20, bottom: 40, width: 50, height: 50 }}
    >
      <div className={styles['my-back-top']}>
        <IconSvg style={{ color: '#fff' }} type="icon-zhiding" />
      </div>
    </BackTop>
  )
})

export default MyBackTop
